
"use client";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import CDNImage from "@/components/cdnImage/cdnImage";
import SafeLink from "@/components/SafeLink";
import { ShopInfoVO } from "@/app/s/components/ShopBanner/type";
import { IExpoTrackParamsRecord, EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25157";

interface Props {
  shopInfoVO: ShopInfoVO;
  eventTrackMap: {
    NormalizedKey: string
    QPParsedLanguage: string
  }
}

export default function ShopBannerSwiper({ shopInfoVO, eventTrackMap }: Props) {
  const [isDataReady, setIsDataReady] = useState(false);
  const { shopActivityInfo, shopId } = shopInfoVO || {};
  const { activityImg, activityJumpUrl } = shopActivityInfo || {};

  if (!activityImg) return null;

  const getExpoParams = () =>
  ({
    shopid: shopId || "-100",
    img: activityImg,
    activity_url: activityJumpUrl,
    ...eventTrackMap
  } as IExpoTrackParamsRecord["Search_ProductList_Background_Expo"]);

  return (
    <Swiper
      slidesPerView={1}
      loop={true}
      pagination={{ clickable: true }}
      autoplay={{ delay: 4000, disableOnInteraction: false }}
      modules={[Pagination, Autoplay]}
      style={{
        visibility: isDataReady ? "visible" : "hidden",
        borderRadius: "6px",
      }}
      onSwiper={() => setIsDataReady(true)}
    >
      <SwiperSlide>
        <SafeLink
          href={activityJumpUrl ?? `/store/${shopId}`}
          onClick={() => {
            sendClickTrack.Search_ProductList_Background({
              shopid: shopInfoVO?.shopId || "-100",
              img: activityImg || "-100",
              activity_url: activityJumpUrl || "-100",
              ...eventTrackMap
            });
          }}
        >
          <div
            exptag={`exp|${EXPOSURE_RECORD.Search_ProductList_Background_Expo}`}
            data-exptag-config='{"useClick": false, "stay_duration": 0.3, "repeated":false, "area_rate": 0.5}'
            data-exptag-json-param={JSON.stringify(getExpoParams())}
          >
            <CDNImage src={activityImg} errorImgType={1} width={1264} alt="shop banner" height={360} style={{ height: 360, objectFit: "cover" }} />
          </div>
        </SafeLink>
      </SwiperSlide>
    </Swiper>
  );
}
